import React, { memo } from "react";

import { classNames } from "helpers";

import { ShowcaseCardProps } from "./types";

/**
 * Kartica na pozornici: uleti sa zadanim kašnjenjem, pa polako lebdi. Kartice stoje ravno.
 */
const ShowcaseCard: React.FC<ShowcaseCardProps> = ({ className, delay, children }) => {
  return (
    <div
      className={classNames("absolute motion-safe:animate-showcaseCardIn", className)}
      style={{ animationDelay: `${delay}s` }}
    >
      {/* h-full: kartica sa zadanom visinom (npr. glavna kartica čarobnjaka) ispuni je cijelu. */}
      <div className="h-full">
        <div
          className="h-full rounded-lg bg-white shadow-[0_1.5rem_3rem_-0.75rem_rgba(15,23,42,0.35)] motion-safe:animate-showcaseFloat"
          style={{ animationDelay: `${delay + 0.8}s` }}
        >
          {children}
        </div>
      </div>
    </div>
  );
};

export default memo(ShowcaseCard);
